import Phaser from 'phaser';
import { GameManager, GameType } from './GameManager';

export class PhaserGame {
  private gameManager: GameManager;

  constructor(container: HTMLElement) {
    this.gameManager = new GameManager(container);
  }

  startGame(gameType: GameType): void {
    this.gameManager.startGame(gameType);
  }

  destroy(): void {
    this.gameManager.destroyCurrentGame();
  }

  getGameManager(): GameManager {
    return this.gameManager;
  }
}
